/// <reference path="../../../../typings/index.d.ts" />

module Meevo {
  'use strict';

  interface IContentHostScope {
    url: string;
    stateName: string;
  }

  class ContentHostCtrl implements IContentHostScope {
    scope: IContentHostScope;
    rootScope: ng.IRootScopeService;
    url: string;
    stateName: string;

    static $inject = ["$state", "$sce"];
    constructor($state: ng.ui.IStateService, $sce: ng.ISCEService) {
      var vm = this;
      var url = $state.current.data.url;
      vm.url = $sce.trustAsResourceUrl(url);
      vm.stateName = $state.current.name;
    }
  }

  angular.module('meevo')
    .controller('ContentHostCtrl', ContentHostCtrl);
}
